import kalkulatorFormTemplate from "./kalkulator-form.pug";
import accessibleSelect from "../../../common/native-accessible-select/native-accessible-select";
import { tooltipHack } from "../../../common/tooltip/tooltip";
import TipusBase from "../lib/tipus-base";
const DEFAULT_AGE = 25;
const DEFAULT_MONTHLY_PAYMENT = 10000;
const DEFAULT_EXPECTED_YIELD = 4;
const DEFAULT_MONTHLY_ANNUITY = 10000;
const DEFAULT_YEARS = 10;
export const KalkulatorFormComponent = {
  template: kalkulatorFormTemplate(),
  transclude: {
    tooltipFormContent: "tooltipFormContent",
  },
  bindings: {
    tipus: "<",
    hozamok: "<",
    vegpontok: "<",
    onCalculate: "&",
    onTabChange: "&",
  },
  controller: class KalkulatorFormController extends TipusBase {
    constructor($scope, $timeout, $element) {
      "ngInject";
      super();
      this.$timeout = $timeout;
      this.$element = $element[0];
      $scope.$watch("$ctrl.expectedYieldTab1", (val) => {
        this.expectedYieldInput = val;
      });
      $scope.$watch("$ctrl.model.age", (val) => {
        this.ageInput = val;
        this.vegpontok && this.isJaradek() && this._setSliderLimits();
      });
      $scope.$watch("$ctrl.vegpontok", (val) => {
        if (val) {
          this._setSliderLimits();
        }
      });

      $scope.$watch("$ctrl.ageInput", (val) => {
        if (val) {
          this.model.age = this.ageInput;
        } else {
          this.model.age = DEFAULT_AGE;
          this.ageInput = DEFAULT_AGE;
        }
      });
      $scope.$watch("$ctrl.model.years", (val) => {
        this.yearsInput = val;
      });
      $scope.$watch("$ctrl.yearsInput", (val) => {
        if (val) {
          this.model.years = this.yearsInput;
        } else {
          this.yearsInput = DEFAULT_YEARS;
          this.model.years = DEFAULT_YEARS;
        }
      });
      $scope.$watch("$ctrl.expectedYieldInput", (val) => {
        if (val) {
          this.expectedYieldTab1 = this.expectedYieldInput;
        } else {
          this.expectedYieldTab1 = DEFAULT_EXPECTED_YIELD;
          this.expectedYieldInput = DEFAULT_EXPECTED_YIELD;
        }
      });
      $scope.$watch("$ctrl.model.monthlyPayment", (val) => {
        this.monthlyPaymentInput = val;
      });
      $scope.$watch("$ctrl.model.monthlyAnnuity", (val) => {
        this.monthlyAnnuityInput = val;
      });
      $scope.$watch("$ctrl.activeTab", (val) => {
        this.kalkulatorForm.$setUntouched();
        this.kalkulatorForm.$setPristine();

        this.onTabChange();
        if (val == 1 || val == 2) {
          this.model.customYield = false;
          setTimeout(() => {
            let selects = Array.from(this.$element.querySelectorAll("select"));
            selects.forEach((item) => {
              setTimeout(() => {
                new accessibleSelect({ element: item });
              }, 0);
            });
          }, 0);
        } else {
          this.model.customYield = true;
        }
      });
    }
    $onInit() {
      this.model = {
        age: DEFAULT_AGE,
      };
      this.activeTab = "0";
      if (this.isMegtakaritas()) {
        this.model.monthlyPayment = DEFAULT_MONTHLY_PAYMENT;
        this.monthlyPaymentInput = this.model.monthlyPayment;
      }
      if (this.isJaradek()) {
        this.model.monthlyAnnuity = DEFAULT_MONTHLY_ANNUITY;
        this.model.years = DEFAULT_YEARS;
        this.yearsInput = this.model.years;
        this.monthlyAnnuityInput = this.model.monthlyAnnuity;
      }
      this.expectedYieldTab1 = DEFAULT_EXPECTED_YIELD;
      this.expectedYieldInput = this.expectedYieldTab1;
      this.ageInput = this.model.age;
      this.ageOptions = {
        floor: 16,
        ceil: 60,
        minLimit: 16,
        maxLimit: 60,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false,
      };
      this.yearsOptions = {
        floor: 5,
        ceil: 45,
        minLimit: 5,
        maxLimit: 45,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false,
      };
      this.monthlyPaymentOptions = {
        floor: 10000,
        ceil: 100000,
        minLimit: 10000,
        maxLimit: 100000,
        step: 1000,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false,
      };
      this.monthlyAnnuityOptions = {
        floor: 5000,
        ceil: 400000,
        minLimit: 5000,
        maxLimit: 400000,
        step: 5000,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false,
      };
      this.expectedYieldOptions = {
        floor: 1,
        ceil: 14,
        minLimit: 1,
        maxLimit: 14,
        enforceRange: true,
        showSelectionBar: true,
        autoHideLimitLabels: false,
      };
      setTimeout(() => {
        let tooltips = Array.from(this.$element.querySelectorAll(".tooltip"));
        tooltips.forEach((item) => {
          setTimeout(() => {
            new tooltipHack();
          }, 0);
        });
      }, 0);
    }
    _setSliderLimits() {
      // megkeresi azt a vegpontot ahol a beallitott eletkor kisebb mint a kovetkezo sor
      if (this.isJaradek()) {
        let vegpont = this.vegpontok.find((item, index, array) => {
          return (
            (array[index + 1] && array[index + 1].age > this.model.age) ||
            typeof array[index + 1] == "undefined"
          );
        });
        this.yearsOptions.floor = this.yearsOptions.minLimit =
          vegpont.minimumAnnuityYears;
        this.monthlyAnnuityOptions.floor = this.monthlyAnnuityOptions.minLimit =
          vegpont.minimumAnnuityAmount;
        this.expectedYieldOptions.ceil = this.expectedYieldOptions.maxLimit =
          vegpont.maximumYield;
        this.monthlyPaymentOptions.floor = this.monthlyPaymentOptions.minLimit =
          vegpont.minimumPayment;
      }
    }
    onMonthlyPaymentBlur(val) {
      if (val) {
        this.model.monthlyPayment = val;
      } else {
        this.model.monthlyPayment = DEFAULT_MONTHLY_PAYMENT;
      }
      this.$timeout(() => {
        this.monthlyPaymentInput = this.model.monthlyPayment;
      });
    }

    onMonthlyAnnuityBlur(val) {
      if (val) {
        this.model.monthlyAnnuity = val;
      } else {
        this.model.monthlyAnnuity = DEFAULT_MONTHLY_ANNUITY;
      }
      this.$timeout(() => {
        this.monthlyAnnuityInput = this.model.monthlyAnnuity;
      });
    }

    isMonthlyAnnuityMinusDisabled() {
      return this.model.monthlyAnnuity == this.monthlyAnnuityOptions.floor;
    }
    isMonthlyAnnuityPlusDisabled() {
      return this.model.monthlyAnnuity == this.monthlyAnnuityOptions.ceil;
    }
    decreaseMonthlyAnnuity() {
      this.model.monthlyAnnuity -= this.monthlyAnnuityOptions.step;
    }
    increaseMonthlyAnnuity() {
      this.model.monthlyAnnuity += this.monthlyAnnuityOptions.step;
    }

    isAgeMinusDisabled() {
      return this.model.age == this.ageOptions.floor;
    }
    isAgePlusDisabled() {
      return this.model.age == this.ageOptions.ceil;
    }
    decreaseAge() {
      this.model.age--;
    }
    increaseAge() {
      this.model.age++;
    }

    isYearsMinusDisabled() {
      return this.model.years == this.yearsOptions.floor;
    }
    isYearsPlusDisabled() {
      return this.model.years == this.yearsOptions.ceil;
    }
    decreaseYears() {
      this.model.years--;
    }
    increaseYears() {
      this.model.years++;
    }

    isExpectedYieldMinusDisabled() {
      return this.expectedYieldTab1 == this.expectedYieldOptions.floor;
    }
    isExpectedYieldPlusDisabled() {
      return this.expectedYieldTab1 == this.expectedYieldOptions.ceil;
    }
    decreaseExpectedYield() {
      this.expectedYieldTab1--;
    }
    increaseExpectedYield() {
      this.expectedYieldTab1++;
    }

    isMonthlyPaymentMinusDisabled() {
      return this.model.monthlyPayment == this.monthlyPaymentOptions.floor;
    }
    isMonthlyPaymentPlusDisabled() {
      return this.model.monthlyPayment == this.monthlyPaymentOptions.ceil;
    }
    decreaseMonthlyPayment() {
      this.model.monthlyPayment -= this.monthlyPaymentOptions.step;
    }
    increaseMonthlyPayment() {
      this.model.monthlyPayment += this.monthlyPaymentOptions.step;
    }

    calculate() {
      if (this.kalkulatorForm.$valid) {
        let data;
        let expectedYield;
        switch (this.activeTab) {
          case "0":
            expectedYield = this.expectedYieldTab1;
            break;
          case "1":
            expectedYield = this.expectedYieldTab2;
            break;
          case "2":
            expectedYield = this.expectedYieldTab3;
            break;
        }
        data = Object.assign({}, this.model, { expectedYield });
        this.onCalculate({ data });
      }
    }
  },
};



// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator-form/kalkulator-form.component.js